import md5 from 'js-md5';
import OSS from 'ali-oss';
import encryp from '@/util/encryp';

let clientParams = {
    endpoint: "",
    region: '',
    bucket: '',
    accessKeyId: '',
    accessKeySecret: '',
    stsToken: ''
}

let key = 'm0b1ycd2ef3g4hi5jk6lm7op8d9fg1';
let filePath = '';
let aseKey = 'e3140fd34ead440755a8fe34ac11f3fd';

/**
 * 调用接口获取临时accessKeyId accessKeySecret
 */
function get_signature(fileFrom, schoolId, userId, suffix) {
    let xmlhttp = null;
    if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
    } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }

    if (xmlhttp != null) {
        if (schoolId != '' && userId != '') {
            filePath = "aliba/resources/" + fileFrom + getDateForPath(schoolId, userId);
        } else {
            filePath = "aliba/resources/" + fileFrom + '/';
        }
        let uuid = generateUUID();
        filePath = filePath + uuid + "/f." + suffix;
        let timestamp = (new Date()).getTime();
        //key+path+时间戳 md5加密
        let secure = md5(key + filePath + timestamp);
        secure = secure.toUpperCase();
        //public/oss/getALiYunSTS
        let serverUrl = process.env.VUE_APP_APIURL + '/public/oss/getStsToken?path=' + filePath + '&timestamp=' + timestamp + '&secure=' + secure + '&type=basefile';
        xmlhttp.open("GET", serverUrl, false);
        xmlhttp.send(null);

        let body = xmlhttp.responseText;
        let obj = encryp.decrypt(eval("(" + body + ")").data, aseKey);
        obj = eval("(" + obj + ")");
        clientParams.endpoint = obj['endpoint'];
        clientParams.region = obj['region'];
        clientParams.bucket = obj['bucket'];
        clientParams.accessKeyId = obj['accessKeyId'];
        clientParams.accessKeySecret = obj['accessKeySecret'];
        clientParams.stsToken = obj['securityToken'];
        
        return true;
    } else {
        alert('您的浏览器不支持XMLHTTP,请换浏览器登录再使用');
    }
}

/**
 * 上传base64图片到阿里云
 */
async function uploadBase64File(file, fileFrom, schoolId, userId, callback) {
    // base64转blob
    const blob = dataURLtoBlob(file);
    //获取文件后缀名
    let suffix = await get_suffix(blob.type);
    //获取临时授权
    await get_signature(fileFrom, schoolId, userId, suffix);

    const client = new OSS(clientParams);
    // blob转arrayBuffer
    const reader = new FileReader();
    reader.readAsArrayBuffer(blob);
    reader.onload = event => {
        // arrayBuffer转Buffer
        const buffer = toBuffer(event.target.result);
        console.log('filePath:' + filePath);
        client
            .put(filePath, buffer)
            .then(res => {
                callback(res.name);
            })
            .catch(err => {
                console.log(err);
            });
    };
}

/**
 * 上传文件到阿里云
 */
async function uploadFile(file, fileFrom, schoolId, userId, callback) {
    //获取文件后缀名
    let suffix = file.name.toLowerCase().split('.').splice(-1)[0];
    //获取临时授权
    await get_signature(fileFrom, schoolId, userId, suffix);

    const client = new OSS(clientParams);

    client.multipartUpload(filePath, file).then(function (result) {
        console.log(result);
        callback(true, result.name);
    }).catch(function (err) {
        console.log(err);
        callback(false, "上传附件失败");
    });
}

/**
 * base64转blob
 */
function dataURLtoBlob(dataurl) {

    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
}

/**
 * 将ArrayBuffer 转化为 Buffer
 */
function toBuffer(ab) {
    var buf = new Buffer(ab.byteLength);
    var view = new Uint8Array(ab);
    for (var i = 0; i < buf.length; ++i) {
        buf[i] = view[i];
    }
    return buf;
}

/**
 * 根据当前时间当前用户的学校id和用户id拼接文件夹路径
 * @returns {string}
 */
function getDateForPath(schoolId, userId) {
    let date = new Date();
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    if (schoolId != "") {
        //当用户学校id不为空时
        return "/" + y + "/" + m + "/" + d + "/" + schoolId + "/" + userId + "/";
    } else {
        //当用户学校id为空时
        return "/" + y + "/" + m + "/" + d + "/" + userId + "/";
    }
}

/**
 * 生产随机id用于拼接上传文件路径
 */
function generateUUID() {
    var s = [];
    var hexDigits = "0123456789abcdefghijklmnopqrstuvwxyz";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23];
    return s.join("");
}

// 截取文件的后缀.
function get_suffix(filename) {
    let pos = filename.lastIndexOf('/');
    let suffix = '';
    if (pos !== -1) {
        suffix = filename.substring(pos + 1)
    }
    return suffix;
}

export {
    uploadBase64File,
    uploadFile
}